import { render, staticRenderFns } from "./WhyAllegiantStadium.vue?vue&type=template&id=4663f792&scoped=true&"
import script from "./WhyAllegiantStadium.vue?vue&type=script&lang=js&"
export * from "./WhyAllegiantStadium.vue?vue&type=script&lang=js&"
import style0 from "./WhyAllegiantStadium.vue?vue&type=style&index=0&id=4663f792&lang=scss&scoped=true&"
import style1 from "./WhyAllegiantStadium.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663f792",
  null
  
)

export default component.exports